<div class="copilot-decision" *ngIf="decision as d">
  <div class="copilot-decision__primary">
    <div
      class="copilot-decision__confidence"
      *ngIf="d.confidence"
      [attr.data-level]="d.confidence.level"
    >
      <mat-icon aria-hidden="true">verified</mat-icon>
      <span>{{ confidenceLabel(d.confidence.level) }} ({{ d.confidence.score }}/100)</span>
    </div>

    <button type="button" class="copilot-decision__toggle" *ngIf="hasDetails" (click)="showDetails = !showDetails"
      [attr.aria-expanded]="showDetails">
      {{ showDetails ? 'Hide details' : 'Why Ask AI thinks this' }}
      <mat-icon>{{ showDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
  </div>

  <!-- Correlation insights above the fold — the most valuable sentence in the answer. -->
  <section class="copilot-decision__correlations" *ngIf="d.correlations?.length">
    <p
      class="copilot-decision__correlation"
      *ngFor="let correlation of d.correlations"
      [attr.data-severity]="correlation.severity"
    >
      <mat-icon aria-hidden="true">{{ correlation.severity === 'warning' ? 'priority_high' : 'insights' }}</mat-icon>
      <span>{{ correlation.interpretation }}</span>
    </p>
  </section>

  <!-- Suggested approach stays above the fold. Recommendation is already in the
       answer as "Next step:" — do not repeat it here. -->
  <section class="copilot-decision__approach" *ngIf="d.suggestedApproach as approach">
    <div class="copilot-decision__approach-title">
      <mat-icon aria-hidden="true">tips_and_updates</mat-icon>
      <strong>{{ approach.title }}</strong>
    </div>
    <p>{{ approach.body }}</p>
  </section>

  <div class="copilot-decision__details" *ngIf="showDetails && hasDetails">
    <section *ngIf="d.observation">
      <h4>What changed</h4>
      <p>{{ d.observation }}</p>
    </section>

    <section *ngIf="d.confidence?.explanation">
      <h4>Confidence</h4>
      <p>{{ d.confidence.explanation }}</p>
      <ul *ngIf="d.confidence.limitations?.length">
        <li *ngFor="let limitation of d.confidence.limitations">{{ limitation }}</li>
      </ul>
    </section>

    <section *ngIf="d.explanations?.length">
      <h4>Key signals</h4>
      <div class="copilot-decision__explanation" *ngFor="let ex of d.explanations">
        <p>{{ ex.summary }}</p>
      </div>
    </section>

    <section class="copilot-decision__coaching" *ngIf="coachingSuggestions?.length">
      <h4>Coaching</h4>
      <div class="copilot-decision__coaching-card" *ngFor="let coaching of coachingSuggestions; let i = index">
        <p class="copilot-decision__coaching-approach">{{ coaching.approach }}</p>
        <div class="copilot-decision__coaching-draft" *ngIf="coaching.draftMessage">
          <p class="copilot-decision__coaching-draft-label">Suggested message</p>
          <p class="copilot-decision__coaching-draft-text">{{ coaching.draftMessage }}</p>
        </div>
        <ul
          class="copilot-decision__coaching-follow-ups"
          *ngIf="coaching.followUpActions?.length"
        >
          <li *ngFor="let tip of coaching.followUpActions">{{ tip }}</li>
        </ul>
      </div>
    </section>

    <section *ngIf="d.signals?.length">
      <h4>Signals</h4>
      <div class="copilot-decision__signals">
        <span
          class="copilot-decision__signal"
          *ngFor="let signal of d.signals"
          [attr.data-severity]="signal.severity"
        >
          {{ signal.type }}
        </span>
      </div>
    </section>

    <section *ngIf="debugMode && d.evidence?.length">
      <h4>Evidence</h4>
      <ul>
        <li *ngFor="let ev of d.evidence">{{ ev.label }}: {{ ev.summary }}</li>
      </ul>
    </section>
  </div>
</div>
